import { useLLMProxyServiceContext } from "contexts/llmProxySerivceContext";
import { getAiActivity } from "graphql/assistant/queries";
import type { GetAiActivityResponse } from "graphql/assistant/queries";
import { useEffect } from "react";
import { useQuery } from "react-query";

const useAIModelsUsage = (email: string, refetchOnUsageUpdate = true) => {
  const {
    usageUpdateSignal
  } = useLLMProxyServiceContext();
  const costs = useQuery<GetAiActivityResponse, Error>(
    ['ai-activity', email],
    () => getAiActivity(email),
    {
      refetchOnWindowFocus: false,
      enabled: !!email
    });

  const { refetch } = costs;

  useEffect(() => {
    // refetch() ignores the `enabled` option, so guard against a missing email here
    if (!refetchOnUsageUpdate || usageUpdateSignal <= 0 || !email) {
      return undefined;
    }

    const timeoutId = setTimeout(() => {
      refetch();
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [usageUpdateSignal, refetch, email, refetchOnUsageUpdate]);

  return {
    models: costs.data?.getAiActivity.models || []
  };
};

export default useAIModelsUsage;
